import { render, staticRenderFns } from "./IcoSquare2.vue?vue&type=template&id=de73f0a8"
import script from "./IcoSquare2.vue?vue&type=script&lang=js"
export * from "./IcoSquare2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports